module.exports = __webpack_public_path__ + "img/facebook_gray.bbbdcdd9.svg";